module.exports = __webpack_public_path__ + "app/principal/modals/modal-unupdated-platform-partner-history-neaICiq6.html";